import * as $ from 'jquery';
import { Component, OnInit, HostListener, AfterViewInit, OnDestroy } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { MatTableDataSource } from '@angular/material/table';
import { LoaderService } from './../../../services/infrastructure/loader.service';
import { ContainerReturnsAddProductSliderModelService } from './container-returns-add-product-slider-model.service';
import { BroadcastService } from './../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../services/infrastructure/config.service';
import { LocalStorageService } from './../../../services/infrastructure/local-storage.service';
import { ContainerReturnService } from '../../../services/container-return/container-return.service';
import { ExcelService } from '../../../services/infrastructure/excel.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-container-returns-add-product',
  templateUrl: './container-returns-add-product.component.html',
  styleUrls: ['./container-returns-add-product.component.scss']
})
export class ContainerReturnsAddProductComponent implements OnInit, AfterViewInit, OnDestroy {
  private subscription = new Subscription();

  filterOptionsData = new Array();
  productAllDataSource: any;
  parentAccountDataSource: any;
  selectedTabIndex = 0;
  filters: any;
  itemList = new Array();
  tabProductList: any;
  selectedProductList = new Array();
  invoiceProductList: any;
  nonInvoiceProductList: any;
  isNoProduct = false;
  isProductNotAdded = true;
  displayedColumns: string[] = ['Product Name', 'detail', 'LotNumber', 'PackageSize', 'ProductLine'];

  constructor(
    public configService: ConfigService,
    public loaderService: LoaderService,
    public broadcastService: BroadcastService,
    public localStorageService: LocalStorageService,
    public containerReturnsService: ContainerReturnService,
    public containerReturnsAddProductSliderModelService: ContainerReturnsAddProductSliderModelService,
    public excelService: ExcelService
  ) {
  }

  ngOnInit(): void {
    this.setFilter();
    this.getProducts(false);
  }

  setFilter() {
    this.filterOptionsData = [
      { label: 'Lot/Serial Number', column: 'conLotNumber' },
      { label: 'Product Name', column: 'productName' },
      { label: 'Item Number', column: 'conItemNumber' },
      { label: 'Package Size', column: 'conPackageSize' },
    ];
  }

  getProducts(isFilter) {
    if (!isFilter) {
      this.filters = {
        accountNumber: this.containerReturnsService.getSelectedAccountNo(),
      };
    }

    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.containerReturnsService.getInvoicedProductItems(this.filters).subscribe((result: any) => {
      if (result) {
        this.tabProductList = result;

        // Filter the data based on selected and not saved
        const newItem = this.containerReturnsAddProductSliderModelService.getNewItem();
        if (newItem != undefined) {
          const data = this.tabProductList.filter(x => !newItem.includes(x.itemId));
          this.tabProductList = data;
        }

        result.forEach(x => {
          if (this.selectedProductList.find(s => s.itemNumber == x.itemNumber && s.lotNumber == x.lotNumber && s.isParent == x.isParent)) {
            x.IsProductSelected = true;
          }
        });

        this.loaderService.setLoaderStatus(false);

        this.invoiceProductList = this.tabProductList.filter(x => x.isParent == false);
        this.productAllDataSource = new MatTableDataSource(this.invoiceProductList);

        this.nonInvoiceProductList = this.tabProductList.filter(x => x.isParent == true);
        this.parentAccountDataSource = new MatTableDataSource(this.nonInvoiceProductList);

        if (isFilter) {
          this.isNoProduct = (this.invoiceProductList.length == 0) ? true : false;
        } else {
          if (this.selectedTabIndex == 0) {
            this.isNoProduct = (this.invoiceProductList.length == 0) ? true : false;
          } else {
            this.isNoProduct = (this.nonInvoiceProductList.length == 0) ? true : false;
          }
        }
        this.setAccInvProdTableHeight();
        this.setcompInvProdTableHeight();
      }
    }));
  }

  // Tab changed
  tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
    this.selectedTabIndex = tabChangeEvent.index;
    if (this.selectedTabIndex === 0) {
      this.setAccInvProdTableHeight();
    } else if (this.selectedTabIndex === 1) {
      this.setcompInvProdTableHeight();
    }
  };

  // set Add product table height
  setAccInvProdTableHeight() {
    const tableHeight = window.innerHeight - $('.prod-top-sec').outerHeight() - $('.mat-tab-header').outerHeight() - $('.add-order-sec').outerHeight() - 65;
    $('.container-return-add-prod .accInvProdTable').css('max-height', tableHeight + 'px');
  }

  setcompInvProdTableHeight() {
    const tableHeight = window.innerHeight - $('.prod-top-sec').outerHeight() - $('.mat-tab-header').outerHeight() - $('.add-order-sec').outerHeight() - 65;
    $('.container-return-add-prod .compInvProdTable').css('max-height', tableHeight + 'px');
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAccInvProdTableHeight();
    this.setcompInvProdTableHeight();
  }

  // Added ngAfterViewInit to calculate height after view loading
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    //this.setAccInvProdTableHeight();
    //this.setcompInvProdTableHeight();
  }

  // Update selected prodcut list
  keepRecords(product, isParentTab) {
    product.IsProductSelected = !product.IsProductSelected;
    const itemNumber = product.itemNumber;
    const lotNumber = product.lotNumber;
    const isParent = product.isParent;
    if (product.IsProductSelected) {
      this.itemList.push({ 'itemNumber': itemNumber, 'lotNumber': lotNumber });
      let item;
      if (isParentTab) {
        item = this.nonInvoiceProductList.filter(i => i.itemNumber == itemNumber && i.lotNumber == lotNumber && i.isParent == isParent);
      } else {
        item = this.invoiceProductList.filter(i => i.itemNumber == itemNumber && i.lotNumber == lotNumber && i.isParent == isParent);
      }

      this.selectedProductList.push(item[0]);
    }
    else {
      let index = this.itemList.findIndex(x => x.itemNumber == itemNumber && x.lotNumber == lotNumber);
      if (index !== -1) {
        this.itemList.splice(index, 1);
      }
      index = this.selectedProductList.findIndex(x => x.itemNumber == itemNumber && x.lotNumber == lotNumber);
      if (index !== -1) {
        this.selectedProductList.splice(index, 1);
      }
    }
    this.enableDisableAddProductBtn();
  }

  // Enable or disable Add product to order btn based on item selection
  enableDisableAddProductBtn() {
    if (this.selectedProductList.length > 0) {
      this.isProductNotAdded = false;
    }
    else {
      this.isProductNotAdded = true;
    }
  }

  // Selected product will add on order
  addSelectedProductToOrder() {
    const data = [];
    if (this.selectedProductList.length > 0) {
      this.selectedProductList.forEach(x => {
        if (x.isParent) {
          data.push(x);
        }
        else {
          if (data && data.length > 0) {
            const hasParentItem = data.filter(d => d.itemNumber == x.itemNumber && d.lotNumber == x.lotNumber && d.isParent == true)[0];
            if (!hasParentItem) {
              data.push(x);
            }
          }
          else {
            data.push(x);
          }
        }
      });
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { productCount: data.length });
    }
    this.containerReturnsAddProductSliderModelService.setData<ContainerReturnsAddProductSliderModelService[]>(data);
    this.containerReturnsAddProductSliderModelService.close();
  }

  // Filter Search
  filterSearchClick(event) {
    this.filters = {
      accountNumber: this.containerReturnsService.getSelectedAccountNo(),
      productName: event.productName,
      packageSize: event.conPackageSize,
      itemNumber: event.conItemNumber,
      lotNumber: event.conLotNumber
    };
    this.getProducts(true);
  }

  // Clear All Filter
  filterClearAllClick(event) {
    this.getProducts(false);
  }

  // Show or Hide Product detail
  showProductDetails(item) {
    item.isSelected = !item.isSelected;
  }

  public export() {
    const exportData = [];
    this.loaderService.setLoaderStatus(true);

    if (this.selectedTabIndex === 0 && this.invoiceProductList && this.invoiceProductList.length > 0) {
      this.invoiceProductList.forEach(x => {
        exportData.push({
          'Product Name': `${x.itemVendorName}/${x.itemDescription}`,
          'Item Number': x.itemNumber,
          'GTIN': x.gtin,
          'Active Ingredients': x.activeIngredients,
          'Lot/Serial Number': x.lotNumber,
          'Package Size': x.packageSize,
          'Product Line': x.productLine
        });
      });
      this.excelService.exportAsExcelFile(exportData, 'AccountProductsReport');
    } else if (this.selectedTabIndex === 1 && this.nonInvoiceProductList && this.nonInvoiceProductList.length > 0) {
      this.nonInvoiceProductList.forEach(x => {
        exportData.push({
          'Product Name': `${x.itemVendorName}/${x.itemDescription}`,
          'Item Number': x.itemNumber,
          'GTIN': x.gtin,
          'Active Ingredients': x.activeIngredients,
          'Lot/Serial Number': x.lotNumber,
          'Package Size': x.packageSize,
          'Product Line': x.productLine
        });
      });
      this.excelService.exportAsExcelFile(exportData, 'ParentProductsReport');
    }
    this.loaderService.setLoaderStatus(false);
  }

  public isDisableExportButton(): boolean {
    let retVal = true;

    if (this.selectedTabIndex === 0 && this.invoiceProductList) {
      retVal = this.invoiceProductList.filter(x => x.displayMessage == null).length === 0;
    } else if (this.selectedTabIndex === 1 && this.nonInvoiceProductList) {
      retVal = this.nonInvoiceProductList.filter(x => x.displayMessage == null).length === 0;
    }

    return retVal;
  }

  public isShowExportButton(): boolean {
    return [0, 1].includes(this.selectedTabIndex);
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
